import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React from "react";
import { ToLocaleFormat } from "../defaultFunctions/formaters";
import { customColors } from "../atoms/customColors";
import { useRecoilState } from "recoil";

interface ItemVendaDigitada {
  id: number;
  idVendaDigitada: number;
  descricao: string;
  valorItem: number;
  quantidade: number;
  codigo: string;
  valorTotalItem: number;
  vendaDigitada: null;
}

interface ModalItensVendaDigitadaProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  itens: ItemVendaDigitada[];
}

export default function ModalItensVendaDigitada({
  isOpen,
  setIsOpen,
  itens,
}: ModalItensVendaDigitadaProps) {
  const finalRef = React.useRef(null);
  const [colors] = useRecoilState(customColors);

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      finalFocusRef={finalRef}
      isOpen={isOpen}
      onClose={onClose}
      size={"5xl"}
    >
      <ModalOverlay backdropFilter="blur(10px)" />
      <ModalContent>
        <ModalHeader>
          <Flex w={"100%"} justifyContent={"center"}>
            <Text fontWeight={"bold"}>Itens da Venda</Text>
          </Flex>
        </ModalHeader>
        <ModalBody>
          <Flex
            w={"100%"}
            alignItems={"flex-start"}
            minHeight={"250px"}
            height={"fit-content"}
            border={"2px solid #c4c4c4"}
            justifyContent={"space-evenly"}
            shadow={"md"}
            borderRadius={"6px"}
          >
            <TableContainer w={"100%"}>
              <Table variant={"striped"} w={"100%"}>
                <Thead>
                  <Tr>
                    <Th bgColor={colors.VARIANT} color={colors.WHITE}>
                      Descrição
                    </Th>
                    <Th bgColor={colors.VARIANT} color={colors.WHITE}>
                      Valor do Item
                    </Th>
                    <Th bgColor={colors.VARIANT} color={colors.WHITE}>
                      Quantidade
                    </Th>
                    <Th bgColor={colors.VARIANT} color={colors.WHITE}>
                      Código
                    </Th>
                    <Th bgColor={colors.VARIANT} color={colors.WHITE}>
                      Valor Total do Item
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {itens && itens.length > 0 ? (
                    itens.map((item) => (
                      <Tr key={item.id}>
                        <Td>{item.descricao}</Td>
                        <Td>{ToLocaleFormat(item.valorItem)}</Td>
                        <Td>{item.quantidade}</Td>
                        <Td>{item.codigo}</Td>
                        <Td>{ToLocaleFormat(item.valorTotalItem)}</Td>
                      </Tr>
                    ))
                  ) : (
                    <Tr>
                      <Td colSpan={5} textAlign={"center"}>
                        Nenhum item disponível
                      </Td>
                    </Tr>
                  )}
                </Tbody>
              </Table>
            </TableContainer>
          </Flex>
        </ModalBody>
        <ModalFooter justifyContent={"space-evenly"}>
          <Button
            background={colors.GRAY}
            color={"white"}
            mr={3}
            onClick={onClose}
          >
            Fechar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
